import { Stack } from '@mui/material';
import React from 'react';
import ItemDetail from './ItemDetail';

function ItemChipSection(props) {
    function calculateItemSpend() {
        if (props.recommendation.type === 'removal') {
            return props.item.cost * (props.item.open_quantity + (props.item.hold_quantity * 0.3)) * (props.yearlyUsage ?? 1) / 100;
        } else if (props.recommendation.type === 'addition') {
            return props.recommendation.item.cost * (props.recommendation.open_quantity + (props.recommendation.hold_quantity * 0.3)) * (props.yearlyUsage ?? 1) / 100;
        } else {
            var openQuantity = props.recommendation.custom_open ?? (props.recommendation.open_quantity ?? 0);
            var holdQuantity = props.recommendation.custom_hold ?? (props.recommendation.hold_quantity ?? 0);
            
            return Math.abs((((props.item.open_quantity - openQuantity) * props.item.cost) + 
                    ((props.item.hold_quantity - holdQuantity) * props.item.cost * 0.3)) * 
                    (props.yearlyUsage ?? 1) / 100);
        }
    }

    return (
        <Stack direction='row' spacing={1}>
            { Object.keys(props.recommendation.context).map((context, index) => (
                <ItemDetail 
                    key={index} 
                    type={context} 
                    data={props.recommendation.context[context]}
                />
            ))}
            <ItemDetail key='cost' type='cost' data={calculateItemSpend()} />
        </Stack>
    )
}

export default ItemChipSection;
